// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.messagebar-container {
    position: absolute;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    pointer-events: none;
    z-index: 3;
}

div.messagebar {
    position: relative;
    flex: 0 0 auto;
    pointer-events: initial;
    display: inline-block;
    max-width: calc(100% - 0.5em);
    padding: 0 1.25em 0 0.25em;
    background-color: var(--container-bg-color);
    box-shadow: 0px 2px 4px rgba(136, 136, 136, 0.5);
    border-top: 1px solid rgba(136, 136, 136, 0.5);
    border-radius: var(--border-radius);
}

div.messagebar > div.body {
    padding: 0.25em 0.5em 0.25em 0.25em;
    display: inline-block;
}

div.messagebar > span.closewrapper {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    padding: 0.125em 0.125em 0 0;
}
`, "",{"version":3,"sources":["webpack://./qwc2/components/style/MessageBar.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,aAAa;IACb,uBAAuB;IACvB,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,uBAAuB;IACvB,qBAAqB;IACrB,6BAA6B;IAC7B,0BAA0B;IAC1B,2CAA2C;IAC3C,gDAAgD;IAChD,8CAA8C;IAC9C,mCAAmC;AACvC;;AAEA;IACI,mCAAmC;IACnC,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,SAAS;IACT,4BAA4B;AAChC","sourcesContent":["div.messagebar-container {\n    position: absolute;\n    left: 0;\n    right: 0;\n    display: flex;\n    justify-content: center;\n    pointer-events: none;\n    z-index: 3;\n}\n\ndiv.messagebar {\n    position: relative;\n    flex: 0 0 auto;\n    pointer-events: initial;\n    display: inline-block;\n    max-width: calc(100% - 0.5em);\n    padding: 0 1.25em 0 0.25em;\n    background-color: var(--container-bg-color);\n    box-shadow: 0px 2px 4px rgba(136, 136, 136, 0.5);\n    border-top: 1px solid rgba(136, 136, 136, 0.5);\n    border-radius: var(--border-radius);\n}\n\ndiv.messagebar > div.body {\n    padding: 0.25em 0.5em 0.25em 0.25em;\n    display: inline-block;\n}\n\ndiv.messagebar > span.closewrapper {\n    position: absolute;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    padding: 0.125em 0.125em 0 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
